import script from "./Pending.vue?vue&type=script&setup=true&lang=js"
export * from "./Pending.vue?vue&type=script&setup=true&lang=js"

import "./Pending.vue?vue&type=style&index=0&id=66a0c6b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a0c6b3"]])

export default __exports__